import axios from 'axios';
import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  loading: false,
  error: null,
  success: false,
};

export const lookUpUserByEmail = createAsyncThunk(
  'addMembers/lookUpUserByEmail',
  async (email, thunkAPI) => {
    try {
      const token = localStorage.getItem('bc_token')
      const { data } = await axios.get(
        process.env.REACT_APP_API_BASE_URL + '/api/user',
        {
          params: { email },
          'headers': {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
      return data
    } catch (error) {
      if (error.response && error.response.data.error) {
        return thunkAPI.rejectWithValue({
          error: error.response.data.error,
          email
        })
      } else {
        return thunkAPI.rejectWithValue({
          error: error.message,
          email
        })
      }
    }
  }
)

export const addMembersSlice = createSlice({
  name: 'add_members',
  initialState,
  reducers: {
    addMember: (state, action) => {
      console.log('[addMember]', action.payload)
      const idx = state.users.findIndex((u) => u.email === action.payload.email)
      if (idx === -1) {
        state.users.unshift(action.payload)
      }
    },
    removeMemberByEmail: (state, action) => {
      console.log('[removeMemberByEmail]', action.payload)
      state.users = state.users.filter((u) => {
        return u.email !== action.payload.email
      })
    },
    reset: (state) => {
      console.log('[addMembers.reset]')
      return initialState
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(lookUpUserByEmail.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = null
      })
      .addCase(lookUpUserByEmail.fulfilled, (state, action) => {
        console.log('[lookUpUserByEmail.fulfilled].before', action);
        const { user } = action.payload
        state.loading = false
        state.success = true
        if (state.users.findIndex((u) => u.email == user.email) == -1) {
          state.users.unshift({
            id: user.id,
            email: user.email,
            name: user.name,
            is_anonymous: user.is_anonymous
          })
        } else {
          state.error = 'User already added'
        }
        console.log('[lookUpUserByEmail.fulfilled].after', current(state))
      })
      .addCase(lookUpUserByEmail.rejected, (state, action) => {
        console.log('[lookUpUserByEmail.rejected]', action)
        state.loading = false
        if (action.payload.error.includes('UserNotFound')) {
          state.success = true
          state.users.unshift({
            id: null,
            name: null,
            email: action.payload.email,
            is_anonymous: true
          })
        } else {
          state.success = false
          state.error = action.payload.error
        }
        console.log('[lookUpUserByEmail.rejected].after', current(state))
      })
  }
});

export const { reset, addMember, removeMemberByEmail } = addMembersSlice.actions

export const selectAddMembersUsers = (state) => state.add_members.users;

export default addMembersSlice.reducer;

